import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogTitle, DialogContent, IconButton, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import useTranslation from 'Hooks/useTranslation';
import style from './style';
import useInput from '../Hooks/useInput';

const { dialogTitle, iconButton, dialogContent, acceptButton } = style;

function AddCourseModal({ acceptText, close, open, onAccept }) {
  const { id } = useSelector(userSelector);
  const { t2 } = useTranslation('Courses');
  const courseName = useInput('');

  const handleAccept = () => {
    if (courseName.value.trim().length === 0) {
      courseName.setError(true);
      courseName.setErrorMessage(t2('MissingName'));
      return;
    }

    close();

    onAccept({ name: courseName.value, isDraft: true, userCreatedId: id });
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="xs" fullWidth>
      <DialogTitle style={dialogTitle}>
        <IconButton onClick={close} style={iconButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={dialogContent}>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label={t2('CourseName')}
          fullWidth
          variant="outlined"
          required
          color="MexlogGreen"
          {...courseName.bind}
        />
        <Button style={acceptButton} color="MexlogGreen" variant="contained" onClick={handleAccept}>
          {acceptText}
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export default AddCourseModal;
